import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "components/CommonForBoth/RightSidebar";
import withRouter from "../../components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { changeLayout, changeLayoutMode, changeTopbarTheme, changeLeftSidebarType, changeLeftSidebarTheme, changeSidebarImageType } from "slices/layouts/thunk";
import { isMobile } from "../../helpers/Helper";

const VerticalLayout = (props: any) => {
  const dispatch: any = useDispatch();

  const selectProperties = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      layoutTypes: layout.layoutTypes,
      layoutModeTypes: layout.layoutModeTypes,
      layoutWidthTypes: layout.layoutWidthTypes,
      topbarThemeTypes: layout.topbarThemeTypes,
      leftSidebarTypes: layout.leftSidebarTypes,
      leftSideBarThemeTypes: layout.leftSideBarThemeTypes,
      leftSidebarImageTypes: layout.leftSidebarImageTypes
    })
  );
  const { layoutTypes,
    layoutModeTypes,
    topbarThemeTypes,
    leftSidebarTypes,
    leftSideBarThemeTypes,
    leftSidebarImageTypes } = useSelector(selectProperties);

  useEffect(() => {
    if (layoutTypes ||
      layoutModeTypes ||
      topbarThemeTypes ||
      leftSidebarTypes ||
      leftSideBarThemeTypes ||
      leftSidebarImageTypes) {
      dispatch(changeLayout(layoutTypes));
      dispatch(changeLayoutMode(layoutModeTypes));
      dispatch(changeTopbarTheme(topbarThemeTypes));
      dispatch(changeLeftSidebarType(leftSidebarTypes));
      dispatch(changeLeftSidebarTheme(leftSideBarThemeTypes));
      dispatch(changeSidebarImageType(leftSidebarImageTypes))
    }
  }, [
    dispatch,
    layoutTypes,
    layoutModeTypes,
    topbarThemeTypes,
    leftSidebarTypes,
    leftSideBarThemeTypes,
    leftSidebarImageTypes]);

  const [open, setOpen] = useState<boolean>(false);
  useEffect(() => {
    if (open) {
      document?.body?.classList?.add("right-bar-enabled")
      document.body.style.paddingRight = ''
    } else {
      document.body.classList.remove("right-bar-enabled")
    }
  }, [open])

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }


  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleCanvas={isMobile() ? () => setOpen(!open) : tToggle} />
        <Sidebar show={open} toggleCanvas={() => setOpen(!open)} />
        <div className="main-content">
          {props.children}
          {!isMobile() && <Footer />}
        </div>
        {/* {isMobile() &&
          <SideMenuContent show={open} toggleCanvas={() => setOpen(!open)} />} */}
        {/* <RightSidebar show={open} toggleCanvas={() => setOpen(!open)} /> */}
      </div>
    </React.Fragment>
  );
};

export default withRouter(VerticalLayout);
